import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=0a076256&scoped=true&lang=pug"
import script from "./FancyButton.vue?vue&type=script&lang=ts"
export * from "./FancyButton.vue?vue&type=script&lang=ts"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=0a076256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a076256",
  null
  
)

export default component.exports